import { defineComponent as _defineComponent } from 'vue'
import EventBus, { EventBusKey } from '@/util/bus'
import { computed } from 'vue'

import type { File, Folder } from './types'


export default /*#__PURE__*/_defineComponent({
  __name: 'MFileItem',
  props: {
    file: null,
    activeId: null,
    draggableData: null
  },
  setup(__props: any) {

const props = __props as {
  file: File
  activeId?: string
  draggableData?: Folder | File
}



const isActive = computed(() => {
  return props.activeId === props.file.id
})
function handleDeleteFile() {
  EventBus.$emit(EventBusKey.CUSTOM_FOLDER_DRAG_EVENT, {
    type: 'delete-file',
    file: props.file,
  })
}

function handleClickFile() {
  EventBus.$emit(EventBusKey.CUSTOM_FOLDER_DRAG_EVENT, {
    type: 'active',
    id: props.file.id,
  })
}

function handleDragStart(e: DragEvent) {
  EventBus.$emit(EventBusKey.CUSTOM_FOLDER_DRAG_EVENT, {
    type: 'drag-start',
    file: props.file,
  })
  e.dataTransfer?.setData(
    'application/json',
    JSON.stringify({ file: props.file })
  )
}

return { __sfc: true,props, isActive, handleDeleteFile, handleClickFile, handleDragStart }
}

})